import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import apiFetch, { condominioHeader } from "../../../../shared/services/apiClient";
import invoiceStyles from "../../invoices/styles/invoice.module.css";
import { overlayClose } from "../../../../shared/utils/overlayClose";
import { ColorSwatches, COLOR_DEFAULT } from "../../../../shared/components/ColorSwatches";

const BASE = process.env.REACT_APP_API_URL ?? "";

async function descargarPDF(url, filename, setLoading, setError) {
  setLoading(true);
  setError("");
  try {
    const token = localStorage.getItem("access_token");
    const extraHeaders = condominioHeader();
    const res = await window.fetch(`${BASE}${url}`, {
      headers: { Authorization: `Bearer ${token}`, ...extraHeaders },
    });
    if (!res.ok) {
      const body = await res.json().catch(() => ({}));
      throw new Error(body.detail || `Error ${res.status}`);
    }
    const blob = await res.blob();
    const href = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = href; a.download = filename; a.click();
    URL.revokeObjectURL(href);
  } catch (e) {
    setError(e.message);
  } finally {
    setLoading(false);
  }
}


function ColorModal({ onConfirm, onCancel }) {
  const { t } = useTranslation();
  const [color, setColor] = useState(COLOR_DEFAULT);
  const [comparativo, setComparativo] = useState(true);

  useEffect(() => {
    apiFetch("/api/residents/condominio/")
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d?.color_reporte) setColor(d.color_reporte); })
      .catch(() => {});
  }, []);

  return (
    <>
      <div {...overlayClose(onCancel)} style={{
        position: "fixed", inset: 0, background: "rgba(0,0,0,0.72)",
        backdropFilter: "blur(5px)", zIndex: 1000,
      }}/>
      <div onClick={e => e.stopPropagation()} style={{
        position: "fixed", top: "50%", left: "50%", transform: "translate(-50%,-50%)",
        background: "var(--bg-card)", border: "1px solid var(--border-card)",
        borderRadius: 16, width: "min(460px,95vw)", zIndex: 1001,
        boxShadow: "0 32px 80px rgba(0,0,0,0.65)", overflow: "hidden",
      }}>
        <div style={{
          background: `linear-gradient(135deg, ${color}22 0%, ${color}08 100%)`,
          borderBottom: "1px solid var(--border-card)", padding: "18px 22px",
          display: "flex", alignItems: "center", gap: 13,
        }}>
          <div style={{
            width: 44, height: 44, borderRadius: 11, flexShrink: 0, background: `${color}22`,
            border: `1px solid ${color}48`, display: "flex", alignItems: "center", justifyContent: "center",
          }}>
            <i className="fa-solid fa-palette" style={{ color, fontSize: "1.15rem" }}/>
          </div>
          <div>
            <div style={{ fontSize: "1rem", fontWeight: 700, color: "var(--text-primary)" }}>
              {t("reportes.opcionesPDF")}
            </div>
            <div style={{ fontSize: "0.74rem", color: "var(--text-muted)", marginTop: 2 }}>
              {t("reportes.configuraPDF")}
            </div>
          </div>
        </div>

        <div style={{ padding: "22px 24px", display: "flex", flexDirection: "column", gap: 18 }}>
          <div>
            <div style={{ fontSize: "0.67rem", fontWeight: 700, letterSpacing: "1.1px",
              textTransform: "uppercase", color: "var(--text-muted)", marginBottom: 10 }}>
              {t("reportes.colorReporte")}
            </div>
            <ColorSwatches value={color} onChange={setColor}/>
            <div style={{ fontSize: "0.74rem", color: "var(--text-muted)", marginTop: 10 }}>
              {t("reportes.colorReporteDesc")}
            </div>
            <div style={{ marginTop: 10, display: "flex", alignItems: "center", gap: 10 }}>
              <div style={{ width: 28, height: 28, borderRadius: 6, background: color,
                border: "1px solid var(--border-card)" }}/>
              <code style={{ fontSize: "0.8rem", color: "var(--text-secondary)" }}>{color}</code>
            </div>
          </div>

          <div style={{ borderTop: "1px solid var(--border-card)", margin: "0 -2px" }}/>

          <label style={{
            display: "flex", alignItems: "center", gap: 13, cursor: "pointer",
            background: "var(--hover-bg)", borderRadius: 9, padding: "12px 14px",
            border: `1px solid ${comparativo ? "rgba(74,222,128,0.3)" : "var(--border-card)"}`,
          }}>
            <input type="checkbox" checked={comparativo}
              onChange={e => setComparativo(e.target.checked)}
              style={{ accentColor: "#4ade80", width: 16, height: 16, flexShrink: 0 }}/>
            <div>
              <div style={{ color: "var(--text-primary)", fontSize: "0.87rem", fontWeight: 600 }}>
                <i className="fa-solid fa-code-compare" style={{ marginRight: 6, color: "#4ade80" }}/>
                {t("reportes.comparativo")}
              </div>
              <div style={{ color: "var(--text-muted)", fontSize: "0.74rem", marginTop: 2 }}>
                {t("reportes.anioAnterior")}
              </div>
            </div>
          </label>
        </div>

        <div style={{
          borderTop: "1px solid var(--border-card)", background: "var(--hover-bg)",
          padding: "14px 24px", display: "flex", justifyContent: "flex-end", gap: 10,
        }}>
          <button onClick={onCancel} style={{
            padding: "9px 18px", background: "transparent", border: "1px solid var(--border-card)",
            borderRadius: 8, color: "var(--text-muted)", fontSize: "0.85rem", cursor: "pointer",
          }}>
            {t("common.cancelar")}
          </button>
          <button onClick={() => onConfirm({ color, comparativo })} style={{
            padding: "9px 22px", background: color, border: "none", borderRadius: 8,
            color: "#fff", fontWeight: 700, fontSize: "0.85rem", cursor: "pointer",
            display: "flex", alignItems: "center", gap: 8,
            boxShadow: `0 4px 16px ${color}66`,
          }}>
            <i className="fa-solid fa-file-pdf"/>
            {t("reportes.generarPDFBtn")}
          </button>
        </div>
      </div>
    </>
  );
}

// ── Componente principal ──────────────────────────────────────────────────────
export default function ReporteEjecutivo() {
  const { t } = useTranslation();
  const now = new Date();

  const SECCIONES = [
    { icon: "fa-chart-column", n: "01", labelKey: "reportes.sec01LabelEj", descKey: "reportes.sec01DescEj", color: "#f97316" },
    { icon: "fa-chart-line",   n: "02", labelKey: "reportes.sec02LabelEj", descKey: "reportes.sec02DescEj", color: "#60a5fa" },
    { icon: "fa-receipt",      n: "03", labelKey: "reportes.sec03LabelEj", descKey: "reportes.sec03DescEj", color: "#a78bfa" },
    { icon: "fa-building-columns", n: "04", labelKey: "reportes.sec04LabelEj", descKey: "reportes.sec04DescEj", color: "#4ade80" },
    { icon: "fa-hand-holding-dollar", n: "05", labelKey: "reportes.sec05LabelEj", descKey: "reportes.sec05DescEj", color: "#facc15" },
    { icon: "fa-table", n: "06", labelKey: "reportes.sec06LabelEj", descKey: "reportes.sec06DescEj", color: "#38bdf8" },
  ];

  const [anio, setAnio] = useState(now.getFullYear());
  const [mesHasta, setMesHasta] = useState(now.getMonth() + 1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);

  function handleGenerar() { setShowModal(true); }

  function handleConfirm({ color, comparativo }) {
    setShowModal(false);
    const qs = new URLSearchParams();
    qs.set("anio", anio);
    qs.set("mes_hasta", mesHasta);
    qs.set("color", color);
    qs.set("comparativo", comparativo ? "true" : "false");
    const url = `/api/finance/reportes/reporte-ejecutivo-pdf/?${qs.toString()}`;
    const fn = `reporte_ejecutivo_${anio}${String(mesHasta).padStart(2, "0")}.pdf`;
    descargarPDF(url, fn, setLoading, setError);
  }

  const MESES = [
    "enero", "febrero", "marzo", "abril", "mayo", "junio",
    "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre",
  ];

  return (
    <>
      <span className={invoiceStyles.inactive}>
        <Link to="/">
          <span className={invoiceStyles.inactive}>{t("common.inicio")} /</span>
        </Link>
        <span className={invoiceStyles.active}> {t("reportes.reporteEjecutivo")}</span>
      </span>
      <div>
        <h2 className="title mt-2 mb-2">{t("reportes.reporteEjecutivo")}</h2>
        <p className="mb-3" style={{ color: "var(--text-muted)" }}>{t("reportes.reporteEjecutivoDesc")}</p>
      </div>

      <div style={{ background: "var(--bg-card)", border: "1px solid var(--border-card)",
        borderRadius: 12, padding: "22px 24px", marginBottom: 24 }}>

        {error && (
          <div style={{ background: "rgba(248,113,113,0.08)",
            border: "1px solid rgba(248,113,113,0.25)", borderLeft: "3px solid #f87171",
            borderRadius: 8, padding: "10px 14px", marginBottom: 18,
            color: "#fca5a5", fontSize: "0.83rem",
            display: "flex", alignItems: "center", gap: 8 }}>
            <i className="fa-solid fa-circle-exclamation"/>
            {error}
          </div>
        )}

        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 16 }}>
          <div>
            <label style={{ display: "block", fontSize: "0.68rem", fontWeight: 700,
              letterSpacing: "1px", textTransform: "uppercase",
              color: "var(--text-muted)", marginBottom: 8 }}>
              {t("reportes.anio")}
            </label>
            <input type="number" value={anio} onChange={e => setAnio(Number(e.target.value))}
              style={{ width: "100%", boxSizing: "border-box", background: "var(--bg-input)",
                border: "1px solid var(--border-input)", borderRadius: 8,
                color: "var(--text-primary)", padding: "10px 14px", fontSize: "0.88rem", fontWeight: 600 }}/>
          </div>
          <div>
            <label style={{ display: "block", fontSize: "0.68rem", fontWeight: 700,
              letterSpacing: "1px", textTransform: "uppercase",
              color: "var(--text-muted)", marginBottom: 8 }}>
              {t("reportes.mesHasta")}
            </label>
            <select value={mesHasta} onChange={e => setMesHasta(Number(e.target.value))}
              style={{ width: "100%", boxSizing: "border-box", background: "var(--bg-input)",
                border: "1px solid var(--border-input)", borderRadius: 8,
                color: "var(--text-primary)", padding: "10px 14px", fontSize: "0.88rem", fontWeight: 600 }}>
              {MESES.map((nombre, i) => (
                <option key={i} value={i + 1}>{nombre.charAt(0).toUpperCase() + nombre.slice(1)}</option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div style={{ marginBottom: 8 }}>
        <p style={{ margin: "0 0 16px", fontSize: "0.7rem", fontWeight: 700,
          letterSpacing: "2px", textTransform: "uppercase",
          color: "var(--text-muted)", textAlign: "center" }}>
          {t("reportes.contenidoPDF")}
        </p>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 12 }}>
          {SECCIONES.map(({ icon, n, labelKey, descKey, color }) => (
            <div key={n} style={{ background: "var(--bg-card)", border: "1px solid var(--border-card)",
              borderRadius: 12, padding: "18px 20px", display: "flex", alignItems: "center", gap: 14,
              position: "relative", overflow: "hidden" }}>
              <span style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)",
                fontSize: "3.8rem", fontWeight: 900, fontFamily: "'Montserrat',sans-serif",
                color: color + "12", lineHeight: 1, userSelect: "none", pointerEvents: "none" }}>
                {n}
              </span>
              <div style={{ width: 42, height: 42, borderRadius: 10, flexShrink: 0,
                background: color + "14", border: `1px solid ${color}28`,
                display: "flex", alignItems: "center", justifyContent: "center" }}>
                <i className={`fa-solid ${icon}`} style={{ color, fontSize: "1rem" }}/>
              </div>
              <div style={{ minWidth: 0 }}>
                <div style={{ fontSize: "0.87rem", fontWeight: 700, color: "var(--text-primary)",
                  lineHeight: 1.3, marginBottom: 3 }}>
                  {t(labelKey)}
                </div>
                <div style={{ fontSize: "0.74rem", color: "var(--text-muted)" }}>{t(descKey)}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ marginTop: 24, display: "flex", justifyContent: "center" }}>
        <button onClick={handleGenerar} disabled={loading} style={{
          background: "#f97316", border: "none", borderRadius: 10, padding: "13px 40px",
          color: "#fff", fontWeight: 700, fontSize: "1rem",
          cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.7 : 1,
          display: "flex", alignItems: "center", gap: 10,
          boxShadow: "0 8px 28px rgba(249,115,22,0.32)" }}>
          {loading
            ? <><i className="fa-solid fa-circle-notch fa-spin"/> {t("reportes.generandoPDF")}</>
            : <><i className="fa-solid fa-file-pdf" style={{ fontSize: "1.1rem" }}/> {t("reportes.generarPDF")}</>}
        </button>
      </div>

      <p style={{ textAlign: "center", marginTop: 12, fontSize: "0.74rem", color: "var(--text-muted)" }}>
        {t("reportes.descargaAuto")}
      </p>

      {showModal && (
        <ColorModal onConfirm={handleConfirm} onCancel={() => setShowModal(false)}/>
      )}
    </>
  );
}
